<div class="widget-panel" [ngStyle]="widgetStyle">
  <ng-content></ng-content>
</div>
